import { ConfigEntityDetail } from '../../types/entities';

export const getRequiredDomainEntityType = (
  entity: ConfigEntityDetail,
  context: string,
): string => {
  const domainEntityType = entity.attributes?.entityMetadata?.domainEntityType;
  if (!domainEntityType) {
    throw new Error(`domainEntityType is required for ${context}`);
  }
  return domainEntityType;
};
